module.exports = __webpack_public_path__ + "img/priority-medium.2f735f2a.svg";